<script setup lang="ts">
export type Props = {
  border?: boolean | '_b5'
  txt: stringI18n | undefined
  on: boolean
  maxWidth?: boolean
  width?: '_wmax'
  small?: boolean
  arrow?: boolean
  nochev?: boolean
  big?: boolean
  disabled?: boolean
  black?: boolean
  grey?: boolean
  red?: boolean
  r9?: boolean
}

defineProps<Props>()
const slots = useSlots()
const icon = computed((): boolean => !!slots.default)
</script>

<template>
  <button
    type="button"
    :disabled
    :class="[
      $style.btn,
      disabled ? $style.disabled : $style.active,
      small ? '_h34' : '_h40',
      icon ? '_pl1' : nochev ? '_pr3' : '_pl2 _pr2',
      !nochev && '_pr3',
      border === '_b5' ? '_b5' : border ? '_b1' : undefined,
      on && 'on',
      grey ? '_bg5' : black ? '_c0 _bg1' : red ? 'red _c0 _bgRed' : !border ? '_bg5' : '_c1 _bg0',
      big && '_wmin240',
      maxWidth ? [$style.maxWidth, '_w100p _h40 _br14'] : r9 ? '_br9 ' : '_br99',
      width,
      arrow && 'IconArrow',
    ]"
  >
    <span :class="$style.wrap">
      <span :class="$style.txt1"
        ><span v-if="icon" class="_row _inline _ctrY"><slot /></span><slot name="txt">{{ txt }}</slot></span
      >
      <span :class="$style.txt2"
        ><span v-if="icon" class="_row _inline _ctrY"><slot /></span><slot name="txt">{{ txt }}</slot></span
      >
    </span>
    <span v-if="!nochev" :class="$style.chev"
      ><slot name="icon"><IconArrow v-if="arrow" :open="on" :class="$style.arr" /><IconChevron v-else :open="on" /></slot
    ></span>
  </button>
</template>

<style module>
.btn {
  composes: global(_relative);
  composes: global(_noflex);

  composes: global(_fw-xl);
  composes: global(_fs09);
  composes: global(_ls-xs);

  --r: 99px;

  /* composes: global(_c1); */
  /* composes: global(_bg5); */
}

.disabled {
  composes: global(_c4);
  cursor: not-allowed;
  background: var(--black-6);
  border-color: var(--black-5);
}

.btn:global(.red) {
  --bg1: var(--black);
}
.btn:global(._br9) {
  --r: 9px;
}
.btn:global(._br14) {
  --r: 14px;
}

.maxWidth {
  composes: global(_spaced);
}
.maxWidth .svg svg {
  /* composes: global(_svg18); */
  height: 18px;
  width: 18px;
}

.wrap {
  composes: global(_relative);
  composes: global(_hidden);
  composes: global(_row);
  composes: global(_w100p);
  composes: global(_noselect);
  z-index: 1;
}

.txt1,
.txt2 {
  transition:
    transform 250ms cubic-bezier(0.23, 1, 0.32, 1),
    opacity 150ms cubic-bezier(0.23, 1, 0.32, 1);
  composes: global(_h100p);
  composes: global(_w100p);

  composes: global(_ctr);

  composes: global(_pt04);
  composes: global(_pr02);
  composes: global(_pb04);
}

.txt1 {
  transition-delay: 100ms;
}
.txt2 {
  composes: global(_absolute);
  composes: global(_inset);
  composes: global(_c0);
  transform: translate3d(0, 100%, 0) rotateX(45deg);
  transform-origin: 50% 100%;
}
.active:global(.on) .txt1,
.active:hover .txt1 {
  opacity: 0;
  transform: translate3d(0, -100%, 0);
  transition-delay: 0s;
}

.active:global(.on) .txt2,
.active:hover .txt2 {
  transform: translateZ(0);
  transition-delay: 0.08s;
}

.active:global(.on) {
  border-color: var(--blue3);
}

.active::after {
  content: '';
  position: absolute;
  top: -1px;
  left: -1px;
  width: calc(100% + 2px);
  height: calc(100% + 2px);
  border-radius: var(--r);
  clip-path: inset(calc(100% - 7px) 7px 7px 7px round var(--r));
  transition: clip-path 0.45s cubic-bezier(0.23, 1, 0.32, 1);
  background: var(--bg1, var(--blue3));
}

.active:hover::after,
.active:global(.on)::after {
  clip-path: inset(0 0 0 0 round var(--r));
}

.chev {
  composes: global(_absolute);
  composes: global(_row);
  composes: global(_ctrY);
  top: 0;
  bottom: 0;
  right: 4px;

  z-index: 1;
}

.active:global(.on) .chev,
.active:hover .chev {
  color: var(--bg);
}
.arr {
  color: var(--black-5);
}
</style>
